import { AfterViewInit, Component, ElementRef, ViewChild, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'hero-widget',
    standalone: true,
    imports: [CommonModule],
    template: `
        <section class="hero-section relative w-full overflow-hidden" aria-label="Hero - Usina Cowork">
            
            <h1 class="visually-hidden">
                Usina Cowork &mdash; Coworking en Buenos Aires | Membresías flexibles, oficinas privadas, salas de reunión y auditorio en Chacarita y San Isidro
            </h1>

            <div class="video-wrapper absolute top-0 left-0 w-full h-full z-0 md:px-6">
                <video #videoPlayer autoplay loop muted playsinline class="w-full h-full object-cover" poster="/assets/video/video-poster.jpg">
                    <source src="/assets/video/hero.mp4" type="video/mp4" />
                </video>
                <div class="video-overlay absolute top-0 left-0 w-full h-full"></div>
            </div>

            <div class="relative z-1 flex align-items-center justify-content-center h-full w-full px-4">
                
                <img src="/assets/img/home/notgeneric-01.png" 
                     alt="Usina Cowork Heading" 
                     class="w-10 h-auto animation-fade-in" />

                <!-- <img src="/assets/img/home/heading.png" 
                     alt="Usina Cowork Heading" 
                     class="block md:hidden w-10 h-auto animation-fade-in" /> -->
            
            </div>

        </section>
    `,
    styles: [`
        /* Altura controlada para mostrar "algo" de la siguiente sección */
        .hero-section {
            height: 60vh; /* Mobile por defecto */
            min-height: 500px;
        }

        /* En desktop, permitimos un poco más de altura pero ponemos tope */
        @media (min-width: 768px) {
            .hero-section {
                height: calc(100vh - 150px); /* Restamos el header aprox */
                max-height: 650px; /* Tope duro según referencia */
            }
        }

        /* Clase standard para SEO (Screen Reader Only) */
        .visually-hidden {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
        }

        /* Animación suave de entrada para el título */
        .animation-fade-in {
            animation: fadeIn 1.5s ease-out;
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }
    `]
})
export class HeroWidget implements AfterViewInit {

    @ViewChild('videoPlayer') videoElement!: ElementRef<HTMLVideoElement>
    private platformId = inject(PLATFORM_ID);


    ngAfterViewInit(): void {
        if (!isPlatformBrowser(this.platformId)) return;
        if (this.videoElement && this.videoElement.nativeElement) {
            const video = this.videoElement.nativeElement;

            // --- iOS / Safari Robustness ---
            // Aseguramos que los atributos críticos estén presentes programáticamente
            video.muted = true;
            video.setAttribute('muted', ''); // Safari a veces ignora la propiedad JS si no está el atributo
            video.playsInline = true;
            video.setAttribute('playsinline', '');

            // Fallback manual para el loop (el atributo 'loop' a veces falla en modo ahorro de iPhone)
            video.addEventListener('ended', () => {
                video.play();
            }, false);

            const playPromise = video.play();

            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    // Autoplay exitoso
                }).catch(error => {
                    console.warn("Autoplay prevenido, reintentando con interacción...", error);
                    // Una técnica común es intentar play() de nuevo en cualquier scroll o toque
                    const retryPlay = () => {
                        video.play();
                        window.removeEventListener('touchstart', retryPlay);
                    };
                    window.addEventListener('touchstart', retryPlay);
                });
            }
        }
    }


}